module.exports = __webpack_public_path__ + "static/media/mobimagetenn.259d4de0.jpeg";